<template>
  <el-card style="width: 100%">
    <div
      slot="header"
      class="clearfix"
    >
      <span>Területi vezetői kimutatás</span>
    </div>
    <div class="filter-container">
      <el-form
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="20" style="display: flex; ">
            <el-form-item
              label="Dátum"
            >
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="dateRangeOptions"
                style="margin-right: 10px;"
                @change="fetchData"
              />
            </el-form-item>

            <el-form-item
              label="Terület"
            >
              <el-select
                v-model="location_id"
                style="width: 100%;"
                @change="fetchData"
                clearable
              >
                <el-option
                  v-for="location in locations"
                  :label="location.value"
                  :value="location.id"
                />
              </el-select>
            </el-form-item>

          </el-col>
          <el-col :span="4">
            <div style="text-align: right; margin-top: 24px;">
              <el-button
                :loading="downloadLoading"
                icon="el-icon-download"
                @click="download"
              >
                Letöltés
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div v-loading="loading">
      <el-table
        :data="data.items"
        style="width: 100%"
        row-key="id"
        border
      >
        <el-table-column
          width="150"
          prop="name"
          label="Képviselő"
          show-overflow-tooltip
          fixed
        >
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>

        <el-table-column
          label="Munkaidő"
        >
          <el-table-column
            prop="workdays"
            label="Munkanapok"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="work_hours"
            label="Ledolgozott órák"
            width="150"
          >
          </el-table-column>
        </el-table-column>

        <el-table-column
          label="Forgalom">
          <template v-for="priceType in data.priceTypes">
            <el-table-column
              width="120"
              :prop="priceType.name"
              :label="priceType.name"
            >
              <template slot-scope="scope">
                {{ scope.row[priceType.id + '_sum'] | currency }}
              </template>
            </el-table-column>
          </template>
          <el-table-column
            prop="special_sum"
            label="Egyedi áras ért."
            width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.special_sum | currency }}
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column
          label="Boltlátogatás"
        >
          <el-table-column
            prop="done_count"
            label="Sikeres"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="failed_count"
            label="Sikertelen"
            width="120"
          >
          </el-table-column>
        </el-table-column>

        <el-table-column
          label="Kintlévőség"
        >
          <el-table-column
            prop="placement_count"
            label="Darab"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="placement_sum"
            label="Érték"
            width="150"
          >
            <template slot-scope="scope">
              {{ scope.row.placement_sum | currency }}
            </template>
          </el-table-column>
          <el-table-column
            prop="placement_old_count"
            label="21 napnál régebbi"
            width="150"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="turnover_to_be_paid"
          label="Befizetésre váró forgalom"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.turnover_to_be_paid | currency }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
  import moment from 'moment';
  import {saveAs} from 'file-saver';


  export default {
    components: {},
    data() {
      const start = moment()
        .startOf('month')
        .format('Y-MM-DD');
      const end = moment()
        .format('Y-MM-DD');
      return {
        location_id: null,
        data: {},
        loading: false,
        downloadLoading: false,
        userLoading: false,
        dateRange: [start, end],
        dateRangeOptions: {
          firstDayOfWeek: 1,
          shortcuts: [{
            text: 'Aktuális hét',
            onClick(picker) {
              const start = moment()
                .weekday(1)
                .toDate();
              const end = moment()
                .weekday(7)
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hét',
            onClick(picker) {
              const start = moment()
                .subtract({weeks: 1})
                .weekday(1)
                .toDate();
              const end = moment()
                .subtract({weeks: 1})
                .weekday(7)
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális hónap',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hónap',
            onClick(picker) {
              const start = moment()
                .subtract({months: 1})
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract({months: 1})
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző 3 hónap',
            onClick(picker) {
              const start = moment()
                .subtract({months: 3})
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract({months: 1})
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális év',
            onClick(picker) {
              const start = moment()
                .startOf('year')
                .toDate();
              const end = moment()
                .endOf('year')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző év',
            onClick(picker) {
              const start = moment()
                .subtract({years: 1})
                .startOf('year')
                .toDate();
              const end = moment()
                .subtract({years: 1})
                .endOf('year')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'YTD',
            onClick(picker) {
              const start = moment()
                .startOf('year')
                .toDate();
              const end = moment()
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'MTD',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      };
    },
    computed: {
      locations() {
        return this.$store.getters['location/locations'];
      },
    },
    watch: {},
    async mounted() {
      this.fetchData();
    },
    methods: {
      async download() {
        this.downloadLoading = true;
        try {
          const excel = await axios({
            url: `api/reports/turnover/download`,
            method: 'POST',
            responseType: 'blob',
            data: {
              from: this.dateRange[0],
              to: this.dateRange[1],
              location_id: this.location_id,
            },
          });
          saveAs(excel, `Teruletivezetoikimutatasxlsx`);
        } catch (e) {
        }
        this.downloadLoading = false;
      },

      async fetchData() {
        this.loading = true;
        let query = `api/reports/turnover?from=${this.dateRange[0]}&to=${this.dateRange[1]}`

        if (this.location_id) {
          query += '&location_id=' + this.location_id;
        }

        this.data = await axios.get(query);
        this.loading = false;
      },
    },

    mounted() {
      this.$store.dispatch('location/fetchAll');
      this.fetchData();
    }
  };
</script>
<style lang="scss">
  .stockValue-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
